import { useContext, useEffect, useRef, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { AuthContext } from '../contexts/AuthContext';
import { forgetShowSession, savedShowSession } from '../lib/showSession';

export default function ShowSessionRestore({ children }) {
    const { userToken } = useContext(AuthContext);
    const location = useLocation();
    const initialPath = useRef(location.pathname);
    const resumed = useRef(false);
    const [showId, setShowId] = useState(null);
    const [ready, setReady] = useState(false);
    useEffect(() => {
        let active = true;
        const restore = async () => {
            if (!userToken) forgetShowSession();
            else if (['/', '/home', '/shows'].includes(initialPath.current)) {
                const id = await savedShowSession(userToken);
                if (active) setShowId(id);
            }
            if (active) setReady(true);
        };
        void restore();
        return () => { active = false; };
    }, [userToken]);
    if (!ready) return <div className="show-room-empty" role="status">Restaurando conexão...</div>;
    if (showId && !resumed.current) {
        if (location.pathname === '/home' || location.pathname === `/shows/${showId}`) {
            resumed.current = true;
        } else {
            return <Navigate to={`/shows/${showId}`} replace />;
        }
    }
    return children;
}
